/**
 * @description
 * get array of objects and return object with counted keys,
 *
 * @param {Array} data
 * @param {string} key
 *
 * @example
 *
 * const data = [{ key1: 'key1', key2: 'key2' }, { key1: 'key1', key2: 'key2' }, { key1: 'key1', key2: 'key2' }];
 * const result = countByKeys(data, 'key1') // { key1: 3 }
 */

export const countByKeys = (
  data: Array<Record<string, any>>,
  key: string
): Record<string, number> => {
  return data.reduce((result, current) => {
    const name = current[key];

    result[name] = result[name] ? result[name] + 1 : 1;

    return result;
  }, {});
};
